<template>

  <div id="detailCanvas" ref="detailCanvas" class="detailContent canvas-box">
    <div class="title">
      <div class="title-name">{{ $t('data.payin_details') }}</div>
      <!-- <img height="25" src="@/assets/logo/logo.svg"> -->
    </div>
    <div class="detail-card">
      <div class="info-amount-txt">{{ $t('data.paid') }}:</div>
      <div class="info-amount">{{ showSourceCurrency }}  {{ merchantInfo.transaction_amount | toDivideWithDot }}</div>
      <div class="info-amount-txt">{{ $t('data.fee') }}:</div>
      <div class="info-amount">{{ showFeeCurrency }}  {{ merchantInfo.fee_split | toDivideWithDot }}</div>
      <div class="line" style="margin-top: 10px;margin-bottom: 8px" />
      <!--
      <div class="modalRow flex">
        <div class="modalCol col-min-width">{{ $t('merchant.merchant_name') }}：</div>
        <div class="modalCol moreBlock">{{ merchantInfo.merchant.merchant_name }} </div>
      </div>
      <div class="modalRow flex">
        <div class="modalCol col-min-width">{{ $t('merchant.merchant_no') }}：</div>
        <div class="modalCol moreBlock">{{ merchantInfo.merchant.merchant_no }} </div>
      </div> -->

      <div class="modalRow flex">
        <div class="modalCol col-min-width">{{ $t('customerService.merchant_order_id') }}：</div>
        <div class="modalCol moreBlock" style="line-height: 1.5">{{ merchantInfo.merchant_order_id }}</div>
      </div>
      <div class="modalRow flex">
        <div class="modalCol col-min-width">{{ merchantInfo.transaction_status === TRANSACTION_STATUS['void']?$t('customerService.original_transaction_id'):$t('customerService.transaction_id') }}：</div>
        <div class="modalCol moreBlock" style="line-height: 1.5">{{ merchantInfo.transaction_id }}</div>
      </div>
      <div v-if="merchantInfo.channel_reference_no" class="modalRow flex">
        <div class="modalCol col-min-width">{{ $t($store.getters.isMX ? 'customerService.ph_invoice_no' : 'customerService.invoice_no') }}：</div>
        <div class="modalCol moreBlock" style="line-height: 1.5">{{ merchantInfo.channel_reference_no }}</div>
      </div>
      <div v-if="merchantInfo.transaction_status === TRANSACTION_STATUS['void']" class="modalRow flex">
        <div class="modalCol col-min-width">{{ $t('customerService.void_transaction_id') }}：</div>
        <div class="modalCol moreBlock">{{ merchantInfo.trans_void_resp&&merchantInfo.trans_void_resp.void_no }}</div>
      </div>
      <div class="modalRow flex">
        <div class="modalCol col-min-width">{{ $t('data.payin_created') }}：</div>
        <div class="modalCol moreBlock">{{ merchantInfo.transaction_create_time }}</div>
      </div>
      <div class="modalRow flex">
        <div class="modalCol col-min-width">{{ $t('data.payin_completed') }}：</div>
        <div class="modalCol moreBlock"> {{ merchantInfo.transaction_return_time }}</div>
      </div>
      <div v-if="merchantInfo.transaction_status === TRANSACTION_STATUS['void']" class="modalRow flex">
        <div class="modalCol col-min-width">{{ $t('customerService.void_complete_time') }}：</div>
        <div class="modalCol moreBlock">{{ merchantInfo.trans_void_resp&&merchantInfo.trans_void_resp.void_complete_time }}</div>
      </div>
      <div class="modalRow flex">
        <div class="modalCol col-min-width">{{ $t('merchant.payment_channel') }}：</div>
        <div class="modalCol moreBlock">{{ merchantInfo.channel_code }}</div>
      </div>
      <div class="modalRow flex">
        <div class="modalCol col-min-width">{{ $t('merchantAccount.recipient_name') }}：</div>
        <div class="modalCol moreBlock">{{ merchantInfo.payer_name | strAesDecryptAndAsterisk }}</div>
      </div>
      <div class="modalRow flex">
        <div class="modalCol col-min-width">{{ $t('data.mobile') }}：</div>
        <div class="modalCol moreBlock">{{ merchantInfo.payer_mobile | strAesDecryptAndAsterisk }}</div>
      </div>
      <div class="modalRow flex">
        <div class="modalCol col-min-width">{{ $t('customerService.pay_card_no') }}：</div>
        <div class="modalCol moreBlock">{{ merchantInfo.desensitization_card_no || '' }}</div>
      </div>
      <div class="modalRow flex">
        <div class="modalCol col-min-width">{{ $t('customerService.pay_card_scheme') }}：</div>
        <div class="modalCol moreBlock">{{ merchantInfo.card_scheme || '' }}</div>
      </div>
      <div class="modalRow flex">
        <div class="modalCol col-min-width">{{ $t('customerService.pay_card_issuer') }}：</div>
        <div class="modalCol moreBlock">{{ merchantInfo.card_issuer || '' }}</div>
      </div>
      <div class="line" style="margin-bottom: 10px; margin-top: 10px" />
      <div class="download-time">{{ $t('data.download_time') }}: {{ Date.now() | parseTime() }}</div>
    </div>

    <el-tag :type="getPayTransactionStatusType(merchantInfo.transaction_status)" class="modalBtn tag-custom"> {{ getPayTransactionStatusMap(merchantInfo.transaction_status) }}</el-tag>
  </div>

</template>

<script>
import html2canvas from 'html2canvas'
import { payTransactionStatusVoidMap } from '@/utils/maps'
export default {
  name: 'PayinDetailDownload',
  props: {
    merchantInfo: {
      type: Object,
      default: function() {
        return {
          merchant: {
            merchant_basic_info: {}
          },
          disbursement_fee: {
          }
        }
      }
    }
  },
  data() {
    this.TRANSACTION_STATUS = {
      void: 4
    }
    return {
    }
  },
  computed: {
    showSourceCurrency() {
      return this.$store.getters.isAllCountry ? this.merchantInfo.source_currency : this.$store.getters.currency
    },
    showFeeCurrency() {
      return this.$store.getters.isAllCountry
        ? this.merchantInfo.fee_split_currency
        : this.$store.getters.currency
    },
    getPayTransactionStatusMap() {
      return function(value) {
        return payTransactionStatusVoidMap(value).label
      }
    },
    getPayTransactionStatusType() {
      return function(value) {
        return payTransactionStatusVoidMap(value).type
      }
    }
  },
  methods: {
    saveImg() {
      const val = 'detailCanvas'
      window.pageYoffset = 0
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      const node = document.getElementById(val)

      const width = node.offsetWidth
      const height = node.offsetHeight
      const scale = 2
      html2canvas(node, {
        width: width,
        heigth: height,
        backgroundColor: '#ffffff',
        dpi: window.devicePixelRatio * 2,
        scale: scale,
        X: 0,
        Y: 0,
        scrollX: -3,
        scrollY: 0,
        useCORS: true,
        allowTaint: true
      }).then(canvas => {
        const url = canvas.toDataURL()
        const a = document.createElement('a')
        a.download = 'Payin_' + (new Date()).getTime()
        const event = new MouseEvent('click')
        a.href = url
        a.dispatchEvent(event)
      })
    },
    onClickCancel() {
      this.changModalStatus(false)
    }
  }
}
</script>
<style scoped lang="scss">
.title{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 31px 10px 25px;
  .title-name{
    font-size: 17px;
    font-weight: 500;
    color: #1D3A71;
    font-family: 'Inter-Medium';
  }
}
.canvas-box{
  position: absolute;
  top: -300vh;
  background: #FFFFFF;
  // display: none;
}
.detail-card{
  margin: 0 17px 10px;
  padding: 7px 10px 10px;
  // box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.16);
  border: 1px solid #EAEAF2;
  border-radius: 10px 10px 0px 0px;
  .info-amount-txt{
    margin-top: 10px;
    font-size: 13px;
    font-weight: 400;
    color: #7E7E7E;
    line-height: 18px;
  }
  .info-amount{
    margin-top: 3px;
    font-size: 15px;
    font-weight: bold;
    color: #333333;
    line-height: 21px;
  }
  .line{
    border-top: 1px solid #EAEAF2;
  }
}
.detailContent{
  width: 410px;
  .flex{
    display: flex;
  }
  .modalRow{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 42px;
  }
  .modalCol{
    flex-basis: 50%;
    font-size: 13px;
    font-weight: 400;
    color: #888888;
    line-height: 2;
  }
  .col-min-width{
    min-width: 150px;
  }
  .moreBlock{
    line-height: 2;
    color: #333333;
  }
  .modalBtn{
    line-height: 25px;
    display: inline-block;
    position: absolute;
    top: 74px;
    right: 27px;
  }
  .download-time{
    text-align: center;
    font-size: 13px;
    font-weight: 400;
    color: #B9B9B9;
    line-height: 1.5;
  }
}

</style>
